import { fileExtension, fileTypeIdentity, fileTypeLabel, formatFileSize, formatUploadedDate, previewKindFor, uploadedSortValue } from '@features/Attachments/utils/fileFormatting';
import { fileAccessLabel } from './fileAccess';
/**
 * Enriches one API row with every display/filter/sort value the surface and columns need.
 *
 * `fileName` is the type source, never `name` — `name` is a user-editable label that usually has
 * no extension. A legacy CarrierWave row still has a filename (the serializer reads it off the
 * uploader), so this holds for both paths; the fallback to `name` exists only for a row whose
 * stored file went missing.
 */
export function toInvoiceAttachmentRow(api, translateFn) {
    var _a, _b, _c;
    const sizeBytes = (_a = api.fileSize) !== null && _a !== void 0 ? _a : 0;
    const typeSource = ((_b = api.fileName) === null || _b === void 0 ? void 0 : _b.trim()) || api.name;
    const createdAt = (_c = api.createdAt) !== null && _c !== void 0 ? _c : '';
    return {
        id: api.id,
        name: api.name,
        createdAt,
        uploadedLabel: createdAt ? formatUploadedDate(createdAt) : '',
        uploadedSortValue: createdAt ? uploadedSortValue(createdAt) : 0,
        sizeBytes,
        // A legacy row whose stored file is gone reports no size. "0 Bytes" would be a statement
        // about its size, and a false one.
        sizeLabel: api.fileSize == null ? '' : formatFileSize(sizeBytes),
        fileAccess: api.fileAccess,
        fileAccessLabel: fileAccessLabel(api.fileAccess, translateFn),
        directUpload: api.directUpload,
        typeLabel: fileTypeLabel(typeSource, translateFn),
        typeFilterValue: fileTypeIdentity(typeSource),
        previewKind: previewKindFor(typeSource),
        extension: fileExtension(typeSource),
        url: api.url
    };
}
